import React, { useEffect, useState } from 'react'
import ClientModal from './ClientModal';
import PageHeader from '../../shared/page-header/PageHeader';
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts';
import axios from 'axios';
import ClientGrid from './ClientGrid';
import { ConvertArrayToXML, getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions} from '../../utils/permissionHelper';
import { logAuditEvent } from '../../utils/auditLogger';

function ClientMain(props) {
  const [getClientList, setClientList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [actionType, setActionType] = useState("Add");
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const [importLogs, setImportLogs] = useState([]);
  const [isImporting, setIsImporting] = useState(false);
  const [resetFileCounter, setResetFileCounter] = useState(0);
  const moduleName = props.Module || 'Clients';
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchClients();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Clients');
  }, [moduleName]);
  function openAddModal() {
    setActionType("Add");
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add client modal');
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const clientModel = data;
      if(clientModel){
        logAuditEvent(moduleName, 'Save Client Attempt', clientModel.ClientId ? `ClientId=${clientModel.ClientId}` : 'Creating new client');
        let clientDetails = {
          ClientId: clientModel.ClientId ? clientModel.ClientId : null,
          TaxStatusId: clientModel.TaxStatusId ? clientModel.TaxStatusId : null,
          ModeOfHoldingId: clientModel.ModeOfHoldingId ? clientModel.ModeOfHoldingId : null,
          ClientRatingsId: clientModel.ClientRatingsId ? clientModel.ClientRatingsId : null,
          ReferedBy: clientModel.ReferedBy ? clientModel.ReferedBy : null,
          TitleId: clientModel.TitleId ? clientModel.TitleId : null,
          ClientName: clientModel.ClientName ? clientModel.ClientName : null, 
          FamilyHeadId: clientModel.FamilyHeadId ? clientModel.FamilyHeadId : null,
          GenderId: clientModel.GenderId ? clientModel.GenderId : null,
          EmailId: clientModel.EmailId ? clientModel.EmailId : null,
          MobileNumber: clientModel.MobileNumber ? clientModel.MobileNumber : null,
          DateOfBirth: clientModel.DateOfBirth ? clientModel.DateOfBirth : null,
          DateOfAnniversary: clientModel.DateOfAnniversary ? clientModel.DateOfAnniversary : null,
          PlaceOfBirth: clientModel.PlaceOfBirth ? clientModel.PlaceOfBirth : null,
          CountryOfBirth: clientModel.CountryOfBirth ? clientModel.CountryOfBirth : null,
          Occupation: clientModel.Occupation ? clientModel.Occupation : null,
          PANNo: clientModel.PANNo ? clientModel.PANNo : null,
          Nominee: clientModel.Nominee ? clientModel.Nominee : null,
          Address: '<Addresses>' + ConvertArrayToXML(clientModel.Address,'<Address>') + '</Addresses>',
          ClientInvestment: clientModel.ClientInvestment ? clientModel.ClientInvestment : null,
          DPID: clientModel.DPID ? clientModel.DPID : null,
          NPSAccountNumber: clientModel.NPSAccountNumber ? clientModel.NPSAccountNumber : null,
          AnnualIncome: clientModel.AnnualIncome ? clientModel.AnnualIncome : null,
          GrossAnnualIncome: clientModel.GrossAnnualIncome ? clientModel.GrossAnnualIncome : null,
          NetWorth: clientModel.NetWorth ? clientModel.NetWorth : null, 
          BankName: clientModel.BankName ? clientModel.BankName : null, 
          BranchName: clientModel.BranchName ? clientModel.BranchName : null, 
          AccountNumber: clientModel.AccountNumber ? clientModel.AccountNumber : null, 
          IFSCCode: clientModel.IFSCCode ? clientModel.IFSCCode : null, 
          LeadId: null,
          UserId: getStorageValues('userId')
        };
        if (validation(clientDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saveClientDetails",
              clientDetails
            );
            if (response.status === 200) {
              if(response.data.data[0].success === 1){
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                logAuditEvent(moduleName, 'Client Saved', clientModel.ClientId ? `ClientId=${clientModel.ClientId}` : 'New client');
                fetchClients();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
            logAuditEvent(moduleName, 'Client Save Failed', error.message || 'Unknown error');
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
    else if (e.target.name === "Import") {
      const file = data?.file;
      logAuditEvent(moduleName, 'Import Client Attempt', file ? `file=${file.name}` : 'No file selected');
      if (!file) {
        CreateAlert("Please select an Excel file to import!!", "Warning", setAlert);
        return;
      }
      setIsImporting(true);
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("UserId", getStorageValues('userId'));
        const response = await axios.post(getApiBaseUrl() + "/importClientExcel", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (response.status === 200) {
          const logs = response.data.logs || [];
          setImportLogs(logs);
          CreateAlert("Client list imported. See details below.", "Success", setAlert);
          logAuditEvent(moduleName, 'Import Client Success', `rows=${logs.length}`);
          fetchClients();
          // keep modal open to show logs
        }
      } catch (error) {
        console.log(error);
        CreateAlert("Error importing file!!", "Error", setAlert);
        logAuditEvent(moduleName, 'Import Client Failed', error.message || 'Unknown error');
      } finally {
        setIsImporting(false);
        setResetFileCounter((c) => c + 1);
      }
    }
  }

  function validation(clientDetails) {
    var validation = true;
    if (clientDetails) {
      if (clientDetails.TaxStatusId === 1){
        if (clientDetails.TitleId === null || clientDetails.TitleId === undefined) {
          CreateAlert("Please select title!!", "Warning", setAlert);
          validation = false;
          return;
        }
      }
      if (clientDetails.ClientName !== null) {
        if (clientDetails.ClientName.length === 0) {
          CreateAlert("Please enter client name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter client name!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.TaxStatusId === null || clientDetails.TaxStatusId === undefined) {
        CreateAlert("Please select Tax status!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.TaxStatusId === 1){
        if (clientDetails.GenderId === null || clientDetails.GenderId === undefined) {
          CreateAlert("Please select Gender!!", "Warning", setAlert);
          validation = false;
          return;
        }
      }
      if (clientDetails.EmailId === null || clientDetails.EmailId === undefined) {
        CreateAlert("Please enter email id!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.MobileNumber === null || clientDetails.MobileNumber === undefined) {
        CreateAlert("Please enter mobile number!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.TaxStatusId === 1){
        if (clientDetails.DateOfBirth === null || clientDetails.DateOfBirth === undefined) {
          CreateAlert("Please enter date of birth!!", "Warning", setAlert);
          validation = false;
          return;
        }
      }
      if (clientDetails.PANNo === null || clientDetails.PANNo === undefined) {
        CreateAlert("Please enter PAN number!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchClients = async () => {
    try {
      let ClientDetails = {
        UserId: getStorageValues('userId'),
        IsForDropdown: 0
      };
      const response = await axios.get(getApiBaseUrl() + "/clientlist", ClientDetails);
      if (response.status === 200) {
        setClientList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const importExcel = () => {
    setActionType("Import");
    setIsOpen(true);
    logAuditEvent(moduleName, 'Import Button Click', 'Opened import clients modal');
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onImport={importExcel}
        showPDF={false}
        showExcel={false}
        showImportExcel={true}
        showPrint={false}
        showRefresh={false}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <ClientGrid 
        ClientData={getClientList} 
        fetchClients={fetchClients} 
        displayModule={props.Module} 
        UserPermissions={getUserModulePermission}
      />
      <ClientModal
        show={modalIsOpen}
        UserAction={actionType}
        displayModule={props.Module}
        onClose={closeModal}
        onSubmit={onSubmit}
        selectedRow={{ logs: importLogs }}
        isImporting={isImporting}
        resetFileCounter={resetFileCounter}
      />
    </>
  )
}

export default ClientMain